import { render, staticRenderFns } from "./Constructor.vue?vue&type=template&id=6dd16736"
import script from "./Constructor.vue?vue&type=script&lang=js"
export * from "./Constructor.vue?vue&type=script&lang=js"
import style0 from "./Constructor.vue?vue&type=style&index=0&id=6dd16736&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports